import clsx from 'clsx';
import { Platforms } from '@/common/constants';
import { usePlatform } from '@/common/hooks';
import { LeagueTableSkeleton } from '@/ui/components';
import { TrackingElements, TrackingEvents, TrackingTabs, useTrack } from '../../tracking';
import { NoDataError, UnableToLoadError } from '../../components';
import { PrematchTableType } from '../../constants';
import { usePrematchData } from '../../hooks';
import { isTableTabEmpty } from './isTableTabEmpty';
import GroupsView from './GroupsView';
import KnockoutView from './KnockoutView';
import LeagueView from './LeagueView';

export default function TableTab() {
  const { table, tableStatus, refetchAll } = usePrematchData();
  const track = useTrack();

  const handleRetryClick = () => {
    track(TrackingEvents.CtaClick, {
      tab: TrackingTabs.Table,
      element: TrackingElements.Retry,
    });
    refetchAll();
  };
  const platform = usePlatform();

  if (tableStatus === 'pending') {
    return (
      <LeagueTableSkeleton
        className={clsx({
          'pt-6 px-3 pb-3': platform === Platforms.MOBILE,
          'pt-3': platform !== Platforms.MOBILE,
        })}
      />
    );
  }

  if (tableStatus === 'error') {
    return <UnableToLoadError onRetryClick={handleRetryClick} />;
  }

  if (table === null || isTableTabEmpty(table)) {
    return <NoDataError />;
  }

  switch (table.type) {
    case PrematchTableType.GROUP_TABLE:
      return <GroupsView />;
    case PrematchTableType.KNOCKOUT:
      return <KnockoutView />;
    case PrematchTableType.TABLE:
      return <LeagueView />;
    default:
      return null;
  }
}
